import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Instagram, Twitter, Mail, MapPin, Phone, Youtube, Linkedin } from 'lucide-react';
import Logo from './Logo';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-white pt-16 pb-8 px-4">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-8 items-start">
        <div className="md:col-span-1">
          <div className="mb-6 transform hover:scale-105 transition-transform duration-300">
            <Logo />
          </div>
          <p className="mb-6 text-stone-400 max-w-xs">
            {t('footer.about')}
          </p>
          <div className="flex space-x-4 mt-4">
            <a href="https://www.instagram.com/cojeco_?igsh=dGxpNWhsNXh6eHZ4" className="text-pink-500 bg-white rounded-full p-2 shadow-lg hover:bg-pink-500 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-pink-500" aria-label="Instagram">
              <Instagram size={28} />
            </a>
            <a href="https://www.linkedin.com/company/cojeco49" className="text-blue-700 bg-white rounded-full p-2 shadow-lg hover:bg-blue-700 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-blue-700" aria-label="LinkedIn">
              <Linkedin size={28} />
            </a>
            <a href="https://www.helloasso.com/associations/cojeco" className="text-green-600 bg-white rounded-full p-2 shadow-lg hover:bg-green-600 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-green-600" aria-label="HelloAsso">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 font-serif text-white">{t('footer.explore')}</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link to="/history" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('nav.history')}
              </Link>
            </li>
            <li>
              {/* <Link to="/gallery" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('nav.activities')}
              </Link> */}
            </li>
            <li>
              <Link to="/about" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('nav.about')}
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 font-serif text-white">{t('footer.legal')}</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/privacy-policy" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('footer.privacy')}
              </Link>
            </li>
            <li>
              <Link to="/terms" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('footer.terms')}
              </Link>
            </li>
            <li>
              <Link to="/cookie-policy" className="text-stone-400 hover:text-primary transition-colors" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                {t('footer.cookies')}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-1 lg:col-span-1">
          <h3 className="text-lg font-semibold mb-4 font-serif text-white">{t('footer.contact')}</h3>
          <ul className="space-y-4">
            <li className="flex items-start">
              <MapPin className="text-primary mr-2 h-5 w-5 mt-0.5" />
              <span className="text-stone-400">Angers, France</span>
            </li>
            <li className="flex items-start">
              <Phone className="text-primary mr-2 h-5 w-5 mt-0.5" />
              <span className="text-stone-400">+33 749033679 (SMS)</span>
            </li>
            <li className="flex items-start">
              <Mail className="text-primary mr-2 h-5 w-5 mt-0.5" />
              <div className="flex flex-col">
                <span className="text-stone-400">contact@cojeco.fr</span>
                <span className="text-stone-400">administration@cojeco.fr</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-stone-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-stone-400 text-sm">
        <p>&copy; {currentYear} CoJeCo. {t('footer.rights')}</p>
      </div>
    </footer>
  );
};